import React from 'react';
import { SiteRegistrationForm } from '../../types';
import FloatingLabel from '../FloatingLabel';
import FormFieldSet from '../FormFieldSet';
import FormSelector from '../FormSelector';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface GeneralStepProps {
    formData: SiteRegistrationForm;
    handleInputChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    display?: boolean;
    prefilledSiteName?: string | null;
}

const GeneralStep: React.FC<GeneralStepProps> = ({ formData, handleInputChange, prefilledSiteName = null, display = false }) => {
    return (
        <FormFieldSet legend="General">
            <div className="grid grid-cols-3 gap-4">
                <FloatingLabel className="col-span-1">
                    <span className={`${!formData.manufacturer && 'text-error'}`}>Manufacturer</span>
                    {display ? <div className={`bg-base-100 border rounded p-2 ${!formData.manufacturer && 'border-error'}`}>{formData.manufacturer ? formData.manufacturer : <span className="flex items-center gap-1 text-error"><ExclamationTriangleIcon className="w-4 h-4" />Required</span>}</div> : (
                        <FormSelector
                            label="Manufacturer"
                            options={["SMA", "Victron"]}
                            optionToItemCallback={(option) => <option key={option} value={option}>{option}</option>}
                            name="manufacturer"
                            value={formData.manufacturer}
                            onChange={handleInputChange!}
                            required={true}
                        />)}
                </FloatingLabel>

                <FloatingLabel className="col-span-2">
                    <span className={`${display && !formData.name && 'text-error'}`}>Site Name</span>
                    {display
                        ? <div className={`bg-base-100 border rounded p-2 ${!formData.name && 'border-error'}`}>{formData.name ? formData.name : <span className="flex items-center gap-1 text-error"><ExclamationTriangleIcon className="w-4 h-4" />Required</span>}</div>
                        : <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            disabled={!!prefilledSiteName}
                            onChange={handleInputChange}
                            className="input focus:outline-none w-full"
                            placeholder="Site Name"
                        />
                    }
                </FloatingLabel>

                <FloatingLabel className="col-span-2">
                    <span className={`${display && !formData.generation_kw && 'text-error'}`}>Solar Capacity</span>
                    {display
                        ? <div className={`bg-base-100 border rounded p-2 ${!formData.generation_kw && 'border-error'}`}>{formData.generation_kw ? formData.generation_kw : <span className="flex items-center gap-1 text-error"><ExclamationTriangleIcon className="w-4 h-4" />Required</span>}</div>
                        : <input
                            type="number"
                            id="generation_kw"
                            name="generation_kw"
                            value={formData.generation_kw}
                            onChange={handleInputChange}
                            className="input focus:outline-none w-full"
                            placeholder="Solar Capacity (kW)"
                        />
                    }
                </FloatingLabel>

                <FloatingLabel className="col-span-2 col-start-1">
                    <span className={`${display && !formData.storage_capacity_kwh && 'text-error'}`}>BESS Storage Capacity</span>
                    {display
                        ? <div className={`bg-base-100 border rounded p-2 ${!formData.storage_capacity_kwh && 'border-error'}`}>{formData.storage_capacity_kwh ? formData.storage_capacity_kwh : <span className="flex items-center gap-1 text-error"><ExclamationTriangleIcon className="w-4 h-4" />Required</span>}</div>
                        : <input
                            type="number"
                            id="storage_capacity_kwh"
                            name="storage_capacity_kwh"
                            value={formData.storage_capacity_kwh}
                            onChange={handleInputChange}
                            className="input focus:outline-none w-full"
                            placeholder="BESS Storage Capacity (kWh)"
                        />
                    }
                </FloatingLabel>
            </div>
        </FormFieldSet>
    );
};

export default GeneralStep;